import React from 'react';
import { useSelector } from 'react-redux';
import { Dropdown, Field, RadioGroup } from '../../../../Core';
import { ListFieldSection } from '../../../../Layout';
import { withInjectedProps } from '../../../../Core/InjectedPropsContext';
import deepEquals from '../../../../../Lib/Object/deepEquals';
import { IWorksheetComponent } from 'Components/Worksheets/Core/types';
import { ISieveSize } from 'Data/ViewModels/Equipment/ISieveSize';
import { pipe } from 'Lib/Hooks/Selectors';

const PreparationSectionBase = ({ createWorksheetSelector }: IWorksheetComponent) => {
  const maximumParticleSizeSieveOptions = useSelector(
    pipe(createWorksheetSelector!('Preparation.AllMaximumParticleSizeSieveSizes'), (ss: ISieveSize[] | undefined) =>
      (ss ?? []).map((s: ISieveSize) => ({
        value: s.Id,
        label: s.Caption,
      }))
    ),
    deepEquals
  );

  return (
    <ListFieldSection>
      <Field
        input={<RadioGroup />}
        label="Procedure"
        name="Preparation.WashingProcedure"
        options={['A', 'B'].map((e) => ({ label: e, value: e }))}
      />
      <Field
        input={<Dropdown />}
        label="Nominal Particle Size"
        name="Preparation.MaximumParticleSizeSieveSizeId"
        options={maximumParticleSizeSieveOptions}
        simpleValue
      />
    </ListFieldSection>
  );
};

const PreparationSection = withInjectedProps(PreparationSectionBase);

export { PreparationSection };
